import { FormName } from '@topconagriculture/feed-types';

import { Ingredient } from '../ingredients/ingredients.types';
import { IngredientInRation } from '../premixes/premixes.types';

export type Recipe = {
  id: string;
  displayName: string;
  description: string;
  externalId: string;
  density: number;
  baseRationId: string;
  baseRationPerc: number;
  targetDMPerc: number;
  adjOnDM: boolean;
  autoAdjWater: boolean;
  premixIngredientId: string;
  premixGroupId: string;
  notInUse: boolean;
  deleted: boolean;
  finalAmount: number;
  finalDryAmount: number;
  finalDryMatterPerc: number;
  finalPricePerCow: number;
  finalAnimalPrice: number;
  finalWeightPrice: number;
  finalPricePerWt: number;
  ingredients: IngredientInRation[];
  transitionDays: number[];
  premixGroup: {};
  weighBackIngredient: Ingredient;
  numberOfIngredients: number;
  numberOfDays: number;
  rationTypeCode: number;
  reqPerc?: number;
  loadWeight?: number;
  loadWeightDry?: number;
  amountDays?: number[];
  percEntryMethod?: number;
  amounts: number[];
  dryAmounts: number[];
  dryMatterPercs: number[];
  weightPrices: number[];
  animalPrices: number[];
  baseRationAmounts?: number[];
  baseRationDryAmounts?: number[];
  baseRationLoadPercs?: number[];
  baseRationDryLoadPercs?: number[];
  roughageDMPercs: number[];
  byproductDMPercs: number[];
  concentrateDMPercs: number[];
  hasPremix: boolean;
  transitionAllowed: boolean;
  finalDateBeforeTransition?: string;
};

export enum RecipeType {
  Unknown = 'unknown_recipe_type',
  Default = 'default_recipe_type',
  AddToBaseRecipe = 'add_to_base_recipe',
  RefusalSubstitute = 'weightback_substitution',
  IngredientResize = 'first_ingredient_resize',
}

export interface RecipeDuplicatePayload {
  recipeId: string;
  description: string;
  displayName?: string;
  formName: FormName;
}

export interface RecipeFilterFormPayload {
  rationName: string;
  hideNotInUse?: boolean;
}
